module.exports = __webpack_public_path__ + "static/img/home11.11584b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home11.png
// module id = AelA
// module chunks = 13